<button
  type="button"
  class="id-card"
  [class.id-card--qr]="variant() === 'qr'"
  [class.id-card--manual]="variant() === 'manual'"
  [class.id-card--documents]="variant() === 'documents'"
  [class.id-card--wide]="variant() === 'documents'"
  [class.id-card--rdv]="variant() === 'rdv'"
  [class.id-card--no-rdv]="variant() === 'no-rdv'"
  [class.id-card--arrival]="variant() === 'arrival'"
  [class.id-card--departure]="variant() === 'departure'"
  (click)="onPress()"
>
  <div class="id-card__content">
    <h2 class="id-card__title">{{ title() }}</h2>
    @if (subtitle()) {
      <p class="id-card__subtitle">{{ subtitle() }}</p>
    }
  </div>

  @if (variant() !== 'documents') {
    <img
      class="id-card__illustration"
      [src]="illustrationSrc()"
      [alt]="illustrationAlt()"
      loading="lazy"
    />
  }
</button>
